
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learning/showcase/vcnow",
      function () {
        return require("private-next-pages/learning/showcase/vcnow/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/learning/showcase/vcnow"])
      });
    }
  